// react-charts/src/Login.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Connexion via l'API
      const response = await axios.post('/api/member/login', { username, password });
      localStorage.setItem('token', response.data.token);
      // Récupérer le profil pour stocker le rôle (optionnel si vous souhaitez le garder en cache)
      const profileRes = await axios.get('/api/member/profile', {
        headers: { Authorization: `Bearer ${response.data.token}` }
      });
      localStorage.setItem('role', profileRes.data.role);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la connexion');
    }
  };

  return (
    <div 
      className="container d-flex align-items-center justify-content-center" 
      style={{ minHeight: "100vh" }}
    >
      <div className="card" style={{ width: "400px" }}>
        <img 
          src="/Godot-et-fils-api.png" 
          alt="Godot et fils API" 
          className="card-img-top" 
        />
        <div className="card-body shadow">
          <h2 className="card-title text-center">Connexion</h2>
          {error && <div className="alert alert-danger">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Nom d'utilisateur</label>
              <input
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Mot de passe</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary w-100">
              Se connecter
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;